export const data = [
  {
    id: 1,
    name: 'AO “Credinta”',
    date: '02.11.2020',
    people_count: 55
  }
]

export const people = [
  {
    id: 1,
    name: 'Darlene Robertson',
    idnp: '200 200 200 2222',
    status: 'active'
  },
  {
    id: 2,
    name: 'Guy Hawkins',
    idnp: '200 200 200 2222',
    status: 'not_analyzed'
  }
]
